import { ALL } from '@/constants';

const STATUS = 'STATUS';

export default {
  namespaced: true,
  state: {
    status: ALL,
  },
  getters: {
    status: state => state.status,
  },
  actions: {
    status({ commit }, payload) {
      commit(STATUS, payload);
    },
    statusAll({ commit }) {
      commit(STATUS, ALL);
    },
  },
  mutations: {
    [STATUS](state, payload) {
      state.status = payload;
    },
  },
};
